import React from 'react';

export interface CopyrightPolicy {
  id: number;
  title: string;
  description: string;
  details: string;
}

interface CopyrightProtectionProps {
  policies: CopyrightPolicy[];
}

const CopyrightProtection: React.FC<CopyrightProtectionProps> = ({ policies }) => {
  return (
    <div className="bg-white py-8">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl font-bold text-gray-800 mb-8">Politici de protecție a drepturilor de autor</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
          {policies.map((policy) => (
            <div 
              key={policy.id} 
              className="border border-gray-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-6 py-4 border-b border-gray-200">
                <h3 className="text-xl font-semibold text-gray-800">{policy.title}</h3>
              </div>
              
              <div className="p-6">
                <p className="text-gray-600 mb-4">{policy.description}</p>
                <p className="text-gray-700">{policy.details}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-10 bg-gray-50 rounded-xl p-6 border border-gray-200">
          <h3 className="text-xl font-bold text-gray-800 mb-4">Raportarea încălcărilor</h3>
          
          <p className="text-gray-600 mb-6">
            Dacă observați orice încălcare a drepturilor de autor pe platforma noastră, vă rugăm să ne informați
            imediat folosind formularul de contact sau la adresa copyright@biblioteca-digitala.ro
          </p>
          
          <div className="bg-white p-6 rounded-lg border border-gray-200">
            <h4 className="text-lg font-semibold text-gray-800 mb-3">Procedura noastră de răspuns</h4>
            
            <ol className="list-decimal list-inside text-gray-600 space-y-3 pl-2">
              <li>Verificăm fiecare sesizare în termen de 24-48 de ore</li>
              <li>Evaluăm materialul raportat și determinăm statutul drepturilor de autor</li>
              <li>Suspendăm temporar accesul la materialele care fac obiectul unei plângeri justificate</li>
              <li>Investigăm cu atenție și decidem acțiunile necesare conform legislației în vigoare</li>
              <li>Vă notificăm despre decizia luată și acțiunile întreprinse</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CopyrightProtection; 